(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InvoiceDetailController', InvoiceDetailController);

    InvoiceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'invoice', 'Invoice'];

    function InvoiceDetailController($scope, $rootScope, $stateParams, previousState, invoice, Invoice) {
        var vm = this;

        vm.invoice = invoice;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:invoiceUpdate', function(event, result) {
            vm.invoice = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
